import LegalPage from "../components/LegalPage";
import site from "../data/site";

function PrivacyPolicy() {
  const sections = [
    {
      heading: "Information We Collect",
      list: [
        "Personal details such as name, email address, and contact number when you contact us",
        "Business-related information shared during consultations or inquiries",
        "Technical data such as IP address, browser type, and device information",
      ],
    },
    {
      heading: "How We Use Your Information",
      list: [
        "To respond to inquiries and provide requested services",
        "To improve our products, services, and website experience",
        "To communicate important updates, offers, or service-related information",
        "To maintain security and prevent unauthorized access",
      ],
    },
    {
      heading: "Data Sharing & Disclosure",
      body: "We do not sell, trade, or rent your personal information to third parties. Your data may only be shared when required by law or to trusted partners who assist us in operating our services, under strict confidentiality agreements.",
    },
    {
      heading: "Data Security",
      body: "We implement appropriate technical and organizational measures to protect your information against unauthorized access, alteration, disclosure, or destruction.",
    },
    {
      heading: "Cookies",
      body: "Our website may use cookies to enhance user experience and analyze site traffic. You can choose to disable cookies through your browser settings.",
    },
    {
      heading: "Third-Party Links",
      body: "Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites.",
    },
    {
      heading: "Policy Updates",
      body: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.",
    },
    {
      heading: "Contact Us",
      body: `If you have any questions about this Privacy Policy or our data practices, please contact us at: ${site.email}`,
    },
  ];

  return (
    <LegalPage
      title="Privacy"
      titleAccent="Policy"
      lead="Your privacy is important to us. This policy explains how we collect, use, and protect your information."
      sections={[
        {
          heading: "Introduction",
          body: `At Odinno, we are committed to safeguarding your personal information. This Privacy Policy outlines how we handle data when you visit our website, use our services, or communicate with us.`,
        },
        ...sections,
      ]}
    />
  );
}

export default PrivacyPolicy;
